module.exports = __webpack_public_path__ + "img/EG.5c6d0e0a.webp";